module.exports = __webpack_public_path__ + "img/24.824cf09f.jpg";